import React, {useState, useContext, useEffect} from "react";
import styled from "styled-components/macro";
import {rgba} from "polished";
import {NavLink, withRouter} from "react-router-dom";
import {darken} from "polished";
import PerfectScrollbar from "react-perfect-scrollbar";
import "../vendor/perfect-scrollbar.css";
import { useHistory } from "react-router-dom";

import {
    Chip,
    Collapse,
    Drawer as MuiDrawer,
    List as MuiList,
    ListItem,
    ListItemText,
    Typography,
} from "@mui/material";

import {ExpandLess, ExpandMore} from "@mui/icons-material";

import {sidebarRoutes as routes} from "../routes/neo-routes";

import logo from "../PFSCM_Logo.png";
import {CurrentUserContext} from "./CurrentUserContext";

const Drawer = styled(MuiDrawer)`
  border-right: 0;

  > div {
    border-right: 0;
  }
`;

const Scrollbar = styled(PerfectScrollbar)`
  background-color: ${(props) => props.theme.sidebar.background};
  border-right: 1px solid rgba(0, 0, 0, 0.12);
`;

const List = styled(MuiList)`
  background-color: ${(props) => props.theme.sidebar.background};
`;

const Items = styled.div`
  padding-top: ${(props) => props.theme.spacing(2.5)};
  padding-bottom: ${(props) => props.theme.spacing(2.5)};
`;

const Brand = styled(ListItem)`
  font-size: ${(props) => props.theme.typography.h5.fontSize};
  font-weight: ${(props) => props.theme.typography.fontWeightMedium};
  color: ${(props) => props.theme.sidebar.header.color};
  background-color: ${(props) => props.theme.sidebar.header.background};
  font-family: ${(props) => props.theme.typography.fontFamily};
  min-height: 56px;
  padding-left: ${(props) => props.theme.spacing(6)};
  padding-right: ${(props) => props.theme.spacing(6)};
  justify-content: center;
  cursor: pointer;

  ${(props) => props.theme.breakpoints.up("sm")} {
    min-height: 64px;
  }

  &:hover {
    background-color: ${(props) => props.theme.sidebar.header.background};
  }
`;


const Category = styled(ListItem)`
  padding-top: ${(props) => props.theme.spacing(3)};
  padding-bottom: ${(props) => props.theme.spacing(3)};
  padding-left: ${(props) => props.theme.spacing(8)};
  padding-right: ${(props) => props.theme.spacing(7)};
  font-weight: ${(props) => props.theme.typography.fontWeightRegular};

  svg {
    color: ${(props) => props.theme.sidebar.color};
    font-size: 20px;
    width: 20px;
    height: 20px;
    opacity: 0.5;
  }

  &:hover {
    background: rgba(0, 0, 0, 0.08);
  }

  &.${(props) => props.activeClassName} {
    background-color: ${(props) =>
            darken(0.03, props.theme.sidebar.background)};

    span {
      color: ${(props) => props.theme.sidebar.color};
    }
  }
`;

const CategoryText = styled(ListItemText)`
  margin: 0;

  span {
    color: ${(props) => props.theme.sidebar.color};
    font-size: ${(props) => props.theme.typography.body1.fontSize}px;
    padding: 0 ${(props) => props.theme.spacing(4)};
  }
`;

const CategoryIconLess = styled(ExpandLess)`
  color: ${(props) => rgba(props.theme.sidebar.color, 0.5)};
`;

const CategoryIconMore = styled(ExpandMore)`
  color: ${(props) => rgba(props.theme.sidebar.color, 0.5)};
`;

const Link = styled(ListItem)`
  padding-left: ${(props) => props.theme.spacing(14.5)};
  padding-top: ${(props) => props.theme.spacing(2)};
  padding-bottom: ${(props) => props.theme.spacing(2)};

  span {
    color: ${(props) => rgba(props.theme.sidebar.color, 0.7)};
  }

  &:hover span {
    color: ${(props) => rgba(props.theme.sidebar.color, 0.9)};
  }

  &:hover {
    background-color: ${(props) =>
            darken(0.015, props.theme.sidebar.background)};
  }

  &.${(props) => props.activeClassName} {
    background-color: ${(props) =>
            darken(0.03, props.theme.sidebar.background)};

    span {
      color: ${(props) => props.theme.sidebar.color};
    }
  }
`;

const LinkText = styled(ListItemText)`
  color: ${(props) => props.theme.sidebar.color};

  span {
    font-size: ${(props) => props.theme.typography.body1.fontSize}px;
  }

  margin-top: 0;
  margin-bottom: 0;
`;

const LinkBadge = styled(Chip)`
  font-size: 11px;
  font-weight: ${(props) => props.theme.typography.fontWeightBold};
  height: 20px;
  position: absolute;
  right: 28px;
  top: 8px;
  background: ${(props) => props.theme.sidebar.badge.background};

  span.MuiChip-label,
  span.MuiChip-label:hover {
    cursor: pointer;
    color: ${(props) => props.theme.sidebar.badge.color};
    padding-left: ${(props) => props.theme.spacing(2)};
    padding-right: ${(props) => props.theme.spacing(2)};
  }
`;

const CategoryBadge = styled(LinkBadge)`
  top: 12px;
`;

const SidebarSection = styled(Typography)`
  color: ${(props) => props.theme.sidebar.color};
  padding: ${(props) => props.theme.spacing(4)} ${(props) => props.theme.spacing(7)} ${(props) => props.theme.spacing(1)};
  opacity: 0.9;
  display: block;
`;

const SidebarCategory = ({
                             name,
                             icon,
                             classes,
                             isOpen,
                             isCollapsable,
                             badge,
                             ...rest
                         }) => {


    return (
        <Category {...rest}>
            {icon}
            <CategoryText>{name}</CategoryText>
            {isCollapsable ? (
                isOpen ? (
                    <CategoryIconMore/>
                ) : (
                    <CategoryIconLess/>
                )
            ) : null}
            {badge ? <CategoryBadge label={badge}/> : ""}
        </Category>
    );
};

const SidebarLink = ({name, to, badge, icon}) => {
    return (
        <Link
            button
            dense
            component={NavLink}
            exact
            to={to}
            activeClassName="active"
        >
            <LinkText style={{paddingLeft: 40}}>{name}</LinkText>
            {badge ? <LinkBadge label={badge}/> : ""}
        </Link>
    );
};

const Sidebar = ({classes, staticContext, location, ...rest}) => {
  const routeIndex = localStorage.getItem('index');
  const roleList = localStorage.getItem('Roles');
  const [accessChild, SetAccessChild] = useState('false');
  let roleSet = '';
  if(roleList){
    roleSet = roleList.split(',');   
    }

    const initOpenRoutes = () => {
        /* Open collapse element that matches current url */
        const pathName = location.pathname;
        let _routes = {};        
        routes?.forEach((route, index) => {
          if(route.innerParent && routeIndex === "1"){            
           route.innerParent.forEach((innerRoute) => {        
            _routes = {0: undefined, 1: true}
           })
          }else  if(roleSet.includes('ROLE_SI_USER') && roleSet.indexOf('ROLE_ADMIN') === -1 && routeIndex === "0"){
            if(route.innerParent){
              route.innerParent.forEach((innerRoute) => {        
                _routes = {0: true, 1: undefined}
               })
            }
         }else if(route.innerParent && routeIndex === "0" && roleSet.indexOf('ROLE_ADMIN') > -1){    
          route.innerParent.forEach((innerRoute) => {        
           _routes = {0: true, 1: undefined}
          })
         }else {
            const isActive = pathName.indexOf(route.path) === 0;
            const isOpen = route.open;
            const isHome = route.containsHome && pathName === "/";

            _routes = Object.assign({}, _routes, {
                [index]: isActive || isOpen || isHome,
            });            
          }
          
        });

        return _routes;
    };

    const initNestedOpenRoutes = () => {
      /* Open collapse element that matches current url */
      const pathName = location.pathname;
      let _routes = {};      
      let siRoute = routes.find(el => el.id === 'Shipping Instructions');
      siRoute.innerParent.forEach((route, index) => {
          const isActive = pathName.indexOf(route.path) === 0;
          const isOpen = route.open;
          const isHome = route.containsHome && pathName === "/";

          _routes = Object.assign({}, _routes, {
              [index]: isActive || isOpen || isHome,
          });
      });

      return _routes;
  };

    const [openRoutes, setOpenRoutes] = useState(() => initOpenRoutes());
    const [openNestedRoutes, setNestedOpenRoutes] = useState(() => initNestedOpenRoutes());
    const history = useHistory();
    
    const toggle = (index) => {
       // Collapse all elements
       console.log(openRoutes)
       localStorage.setItem('index', index);
        Object.keys(openRoutes).forEach(
            (item) =>
                openRoutes[index] ||
                setOpenRoutes((openRoutes) =>
                    Object.assign({}, openRoutes, {[item]: false})
                )
        );

        // Toggle selected element
        setOpenRoutes((openRoutes) =>
            Object.assign({}, openRoutes, {[index]: !openRoutes[index]})
        );
    };

    
    const toggleNested = (index) => {
      // Collapse all elements
      console.log(openRoutes)
      console.log(openNestedRoutes)

      Object.keys(openNestedRoutes).forEach(
          (item) =>
          openNestedRoutes[index] ||
          setNestedOpenRoutes((openNestedRoutes) =>
                  Object.assign({}, openNestedRoutes, {[item]: false})
              )
      );

      // Toggle selected element
      setNestedOpenRoutes((openNestedRoutes) =>
          Object.assign({}, openNestedRoutes, {[index]: !openNestedRoutes[index]})
      );
   
  };

    const {rights} = useContext(CurrentUserContext);
    // const allowedRoutes = routes.filter(r => (rights.includes(r.right) || !r.right));            
    const allowedRoutes = [];
    routes.map((r) => {
      for(let roles of r.right){
         if(rights.includes(roles) && allowedRoutes.indexOf(r)  === -1){
          allowedRoutes.push(r);
         }
      }
    });

      useEffect(() =>{
        if(rights.includes('ROLE_SI_ADMIN') || rights.includes('ROLE_SI_EDITOR')){
         SetAccessChild(true);
        }else{
          SetAccessChild(false);
        }
     },[rights]);

    return (
        <Drawer variant="permanent" {...rest}>
            <Brand onClick={()=> {history.push("/home")}}>
                <img alt="PFSCM logo" style={{width: '100%'}} src={logo}/>
            </Brand>
            <Scrollbar>
                <List disablePadding>
                    <Items>
                        {allowedRoutes.map((category, index) => (
                            <React.Fragment key={index}>
                                {category.header ? (
                                    <SidebarSection>{category.header}</SidebarSection>
                                ) : null}

                                {category.children && category.icon ? (
                                    <React.Fragment key={index}>
                                        <SidebarCategory
                                            isOpen={!openRoutes[index]}
                                            isCollapsable={true}
                                            name={category.id}
                                            icon={category.icon}
                                            button={true}
                                            onClick={() => toggle(index)}
                                        />                               
                                        <Collapse
                                            in={openRoutes[index]}
                                            timeout="auto"
                                            unmountOnExit
                                        >
                                          {}
                                         {category.children.map((route, index) => (
                                                <SidebarLink
                                                    key={index}
                                                    name={route.name}
                                                    to={route.path}
                                                    icon={route.icon}
                                                    badge={route.badge}
                                                />
                                            ))}
                                           
                                        {accessChild && category.innerParent ? category.innerParent.map((innerParent, index) => (
                                         <React.Fragment  key={index}>
                                        <SidebarCategory style={{left: '20px'}}
                                        isOpen={!openNestedRoutes[index]}
                                        isCollapsable={true}
                                        name={innerParent.id}
                                        icon={innerParent.icon}
                                        button={true}
                                        onClick={() => toggleNested(index)}
                                        />
                                        <Collapse
                                        in={openNestedRoutes[index]}
                                        timeout="auto"
                                        unmountOnExit
                                       >
                                         {innerParent.children.map((route, index) => (
                                            <SidebarLink
                                                key={index}
                                                name={route.name}
                                                to={route.path}
                                                icon={route.icon}
                                                badge={route.badge}
                                            />
                                        ))}

                                    </Collapse>
                                    </React.Fragment>
                                      )) :  null }
                                     
                                        </Collapse>
                                    </React.Fragment>
                                ) : category.icon ? (
                                    <SidebarCategory
                                        isCollapsable={false}
                                        name={category.id}
                                        to={category.path}
                                        activeClassName="active"
                                        component={NavLink}
                                        icon={category.icon}
                                        exact
                                        button
                                        badge={category.badge}
                                    />
                                ) : null}
                            </React.Fragment>
                        ))}
                    </Items>
                </List>
            </Scrollbar>
        </Drawer>
    );
};

export default withRouter(Sidebar);
